import React, { FC } from "react";

import { CircleLoader, CircleLoaderType } from "@shared/components";

import "./ResendCodeLink.scss";

interface Props {
  onClick: () => void;
  status: ResendCodeStatus;
}

enum ResendCodeStatus {
  Normal,
  Sending,
  Sent,
  Error,
}

const ResendCodeLink: FC<Props> = ({ onClick, status }) => {
  const renderResendCodeLink = () => {
    switch (status) {
      case ResendCodeStatus.Sending:
        return (
          <span className="resend-code-link">
            <span>Sending...</span>
            <CircleLoader type={CircleLoaderType.inline} />
          </span>
        );
      case ResendCodeStatus.Sent:
        return (
          <span className="resend-code-link has-text-success">
            <span>Sent!</span>
          </span>
        );
      case ResendCodeStatus.Error:
        return (
          <span className="resend-code-link has-text-danger">
            <span>Failed to send code :(</span>
          </span>
        );
      default:
        return (
          <a onClick={onClick} className="resend-code-link">
            Resend code
          </a>
        );
    }
  };

  return renderResendCodeLink();
};

export { ResendCodeLink, ResendCodeStatus };
